import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/pages/Login'
import Register from '@/components/pages/Register'
import ForgotPassword from '@/components/main/ForgotPassword'
import ActivateAccount from '@/components/main/ActivateAccount'
import GiveConsent from '@/components/main/GiveConsent'
import InvalidToken from '@/components/main/InvalidToken'
import ExpiredAccountToken from '@/components/main/ExpiredAccountToken'
import Admin from '@/components/pages/Admin/Admin'
import AdminDashboard from '@/components/pages/Admin/AdminDashboard'
import Profile from '@/components/pages/Profile'
import SecurityConfiguration from '@/components/pages/Admin/SecurityConfiguration'
import Management from '@/components/pages/Admin/Management'
import Resetting from '@/components/pages/ResetPassword/Resetting'
import Reset from '@/components/pages/ResetPassword/Reset'
import ArticlesList from '@/components/pages/ArticlesList'
import Article from '@/components/pages/Article'
import CategoriesList from '@/components/pages/CategoriesList'
import ChaptersList from '@/components/pages/ChaptersList'
import TagsList from '@/components/pages/TagsList'
import UsersList from '@/components/pages/UsersList'
import AddArticle from '@/components/pages/AddArticle'
import EditArticle from '@/components/pages/EditArticle'
import ExpiredToken from '@/components/pages/ExpiredToken'
import User from '@/components/pages/User'
// new CMS
import NewArticlesList from '@/components/newCmsStyle/page/ArticlesList'
// add user
import AddUser from '@/components/pages/AddUser'
// edit user
import EditUser from '@/components/pages/EditUser'
// company routes
import Company from '@/components/pages/Company'
import CompanySubscription from '@/components/pages/CompanySubscription'
import AddCompany from '@/components/pages/AddCompany'
import EditCompany from '@/components/pages/EditCompany'
import CompanyList from '@/components/pages/CompanyList'
// industry routes
import Industry from '@/components/pages/Industry'
import AddIndustry from '@/components/pages/AddIndustry'
import EditIndustry from '@/components/pages/EditIndustry'
import IndustryList from '@/components/pages/IndustryList'
// Todo part
import Todo from '@/components/admin/todo/Todo'
import TodoList from '@/components/admin/todo/TodoList'
import AddTodo from '@/components/admin/todo/AddTodo'
import EditTodo from '@/components/admin/todo/EditTodo'
// General part
import Error from '@/components/pages/Error'
// users frontend
import Home from '@/components/main/Home'
import Index from '@/components/main/Index'
import Search from '@/components/main/Search'
// import ContentList from '@/components/pages/ContentList'
// import AskExperts from '@/components/main/AskExperts'
import TermsAndConditions from '@/components/main/TermsAndConditions'
import PrivacyPolicy from '@/components/main/PrivacyPolicy'
import AccessibilitySection from '@/components/main/AccessibilitySection'
import Cookies from '@/components/main/Cookies'
import SearchResults from '@/components/main/SearchResults'
import HomePage from '@/components/admin/staticpage/homepage'
import StaticPage from '@/components/admin/staticpage/staticpage'
// import AskPage from '@/components/admin/staticpage/ask'
import Edit from '@/components/main/Edit'
import EditLandingPages from '@/components/main/EditLandingPages'
import DownloadBrochure from '@/components/pages/DownloadBrochure'
import Contact from '@/components/pages/Contact'
import About from '@/components/pages/About'
import ClearKit from '@/components/pages/ClearKit'
// logs
import Logs from '@/components/pages/Logs'
import ConsentLogs from '@/components/pages/ConsentLogs'
import EmailLogs from '@/components/pages/EmailLogs'
import EmailSingle from '@/components/pages/EmailSingle'
// notifications
import Notifications from '@/components/pages/Notifications'
// badge
import Badge from '@/components/pages/Badge'
// subscriptions
import ConfirmSubscription from '@/components/pages/ConfirmSubscription'

import CompanyLanding from '@/components/pages/CompanyLanding'
import EditIndustryEmails from '../components/pages/EditIndustryEmails'
import EditDefaultEmails from '../components/pages/EditDefaultEmails'
import EditIndustryStyling from '../components/pages/EditIndustryStyling'
import EmailPreferences from '../components/pages/EmailPreferences'
import DashboardPromotions from '../components/pages/DashboardPromotions'
import NoPermissions from '../components/pages/NoPermissions'
import CompanyRegistrationLanding from '../components/pages/CompanyRegistrationLanding'
import Redirects from '../components/pages/Redirects'
import Tasks from '../components/pages/Tasks'
import Task from '../components/pages/Task'
import KnowledgeBase from '../components/pages/KnowledgeBase'
import NextGenDashboard from '../components/pages/Admin/NextGenDashboard'
import NextGenArticle from '../components/pages/NextGenArticle'
import CompanyProfile from '../components/pages/CompanyProfile'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '',
          name: 'home',
          component: Index,
          meta: {
            dashboardRedirect: true
          }
        },
        {
          path: 'search',
          name: 'search',
          component: Search,
          meta: { requiresAuth: true }
        },
        {
          path: '/things-to-do',
          name: 'ttd-category',
          props: true,
          redirect: {
            name: 'tasks'
          }
        },
        {
          path: '/content/:id',
          name: 'content',
          props: true,
          component: NextGenArticle,
          meta: { requiresAuth: true }
        },
        // {
        //   path: '/ask-experts',
        //   name: 'AskExperts',
        //   component: AskExperts,
        //   meta: { requiresAuth: true }
        // },
        {
          path: '/terms-and-conditions',
          name: 'terms-and-conditions',
          component: TermsAndConditions
        },
        {
          path: '/privacy-policy',
          name: 'privacy-policy',
          component: PrivacyPolicy
        },
        {
          path: '/accessibility-section',
          name: 'accessibility-section',
          component: AccessibilitySection
        },
        {
          path: '/cookies',
          name: 'cookies',
          component: Cookies
        },
        {
          path: '/give-consent',
          name: 'give-consent',
          component: GiveConsent,
          meta: { requiresAuth: true }
        },
        {
          path: '/profile',
          name: 'profile',
          component: Profile,
          meta: { requiresAuth: true }
        },
        {
          path: '/profile/email-preferences',
          name: 'email-preferences',
          component: EmailPreferences,
          meta: { requiresAuth: true }
        },
        {
          path: '/company/profile',
          name: 'company-profile',
          component: CompanyProfile,
          meta: {
            requiresAuth: true,
            requiresAuthCARU: true
          }
        },
        {
          path: '/company/subscription',
          name: 'company-subscription',
          component: CompanySubscription,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/search-results',
          name: 'SearchResults',
          component: SearchResults,
          meta: { requiresAuth: true }
        },
        {
          path: '/forgot-password',
          name: 'forgot-password',
          component: ForgotPassword,
          meta: { isAuthorized: true }
        },
        {
          path: '/no-permissions',
          name: 'no-permissions',
          component: NoPermissions
        },
        {
          path: '/activate-account/:token',
          name: 'activate-account',
          props: true,
          component: ActivateAccount
        },
        {
          path: '/expired-token',
          name: 'expired-token',
          component: ExpiredToken,
          meta: { isAuthorized: true }
        },
        {
          path: '/invalid-token',
          name: 'invalid-token',
          component: InvalidToken,
          meta: { isAuthorized: true }
        },
        {
          path: '/expired-activation-token',
          name: 'expired-activation-token',
          component: ExpiredAccountToken,
          meta: { isAuthorized: true }
        },
        {
          path: '/resetting',
          name: 'resetting',
          component: Resetting,
          children: [
            {
              path: 'reset/:token',
              name: 'reset',
              props: true,
              component: Reset
            }
          ]
        },
        {
          path: '/landing-page',
          component: Edit,
          children: [
            {
              path: '',
              name: 'edit-pages-list',
              component: EditLandingPages,
              meta: {
                requiresAuth: true,
                requiresAuthGM: true
              }
            },
            {
              path: 'login/edit',
              name: 'edit-login',
              component: Login,
              meta: {
                requiresAuth: true,
                requiresAuthGM: true
              }
            },
            {
              path: 'download-brochure/edit',
              name: 'edit-download-brochure',
              component: DownloadBrochure,
              meta: {
                requiresAuth: true,
                requiresAuthGM: true
              }
            },
            {
              path: 'contact/edit',
              name: 'edit-contact',
              component: Contact,
              meta: {
                requiresAuth: true,
                requiresAuthGM: true
              }
            },
            {
              path: 'homepage/edit',
              name: 'edit-homepage',
              component: Index,
              meta: {
                requiresAuth: true,
                requiresAuthGM: true
              }
            },
            {
              path: 'about/edit',
              name: 'edit-about',
              component: About,
              meta: {
                requiresAuth: true,
                requiresAuthGM: true
              }
            },
            {
              path: 'clear-kit/edit',
              name: 'edit-clear-kit',
              component: ClearKit,
              meta: {
                requiresAuth: true,
                requiresAuthGM: true
              }
            },
            // {
            //   path: 'ask-experts/edit',
            //   name: 'edit-ask-expert',
            //   component: AskExperts,
            //   meta: {
            //     requiresAuth: true,
            //     requiresAuthGM: true
            //   }
            // },
            {
              path: 'terms-and-conditions/edit',
              name: 'edit-terms-and-conditions',
              component: TermsAndConditions
            },
            {
              path: 'privacy-policy/edit',
              name: 'edit-privacy-policy',
              component: PrivacyPolicy
            },
            {
              path: 'accessibility-section/edit',
              name: 'edit-accessibility-section',
              component: AccessibilitySection
            },
            {
              path: 'cookies/edit',
              name: 'edit-cookies',
              component: Cookies
            },
            {
              path: 'give-consent/edit',
              name: 'edit-give-consent',
              component: GiveConsent
            },
            {
              path: 'confirm-subscription/edit',
              name: 'edit-confirm-subscription',
              component: ConfirmSubscription
            }
          ]
        },
        {
          path: '/login',
          name: 'login',
          component: Login,
          meta: {
            isAuthorized: true,
            maybeLanding: true
          }
        },
        {
          path: '/download-brochure',
          name: 'download-brochure',
          component: DownloadBrochure
        },
        {
          path: '/contact',
          name: 'contact',
          component: Contact
        },
        {
          path: '/about',
          name: 'about',
          component: About
        },
        {
          path: '/clear-kit',
          name: 'clear-kit',
          component: ClearKit
        },
        {
          path: '/confirm-subscription/:id',
          name: 'confirm-subscription',
          component: ConfirmSubscription
        },
        {
          path: '/landing/:id',
          name: 'company-landing',
          component: CompanyLanding
        },
        {
          path: '/landing/:industry/:company/register',
          name: 'company-registration-landing',
          component: CompanyRegistrationLanding
        },
        {
          path: '/landing/:id/edit',
          name: 'edit-company-landing',
          component: CompanyLanding,
          meta: {
            requiresAuth: true,
            requiresAuthGM: true
          }
        },
        {
          path: '/landing/:industry/register/edit',
          name: 'edit-company-registration-landing',
          component: CompanyRegistrationLanding,
          meta: {
            requiresAuth: true,
            requiresAuthGM: true
          }
        }
      ]
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: { isAuthorized: true }
    },
    {
      path: '/admin',
      component: Admin,
      meta: {
        requiresAuth: true,
        requiresAuthGM: true
      },
      children: [
        {
          path: '',
          name: 'admin',
          meta: {
            requiresAuthGM: true
          },
          component: AdminDashboard
        },
        {
          path: 'logs',
          name: 'logs',
          component: Logs
        },
        {
          path: 'consent-logs',
          name: 'consent-logs',
          component: ConsentLogs
        },
        {
          path: 'email-logs',
          name: 'email-logs',
          component: EmailLogs
        },
        {
          path: 'email/:id',
          name: 'email-view',
          component: EmailSingle
        },
        {
          path: 'notifications',
          name: 'notifications',
          component: Notifications
        },
        {
          path: 'management',
          name: 'management',
          component: Management
        },
        {
          path: 'security-configuration',
          name: 'security-configuration',
          component: SecurityConfiguration
        },
        {
          path: 'articles-list',
          name: 'articles-list',
          component: ArticlesList
        },
        {
          path: 'article',
          name: 'article',
          component: Article,
          children: [
            {
              path: 'add',
              name: 'add-article',
              component: AddArticle
            },
            {
              path: 'edit/:id',
              name: 'edit-article',
              component: EditArticle
            }
          ]
        },
        {
          path: 'todo',
          name: 'todo',
          component: Todo,
          children: [
            {
              path: 'add',
              name: 'add-todo',
              component: AddTodo
            },
            {
              path: 'edit/:id',
              name: 'edit-todo',
              component: EditTodo
            }
          ]
        },
        {
          path: 'todo-list',
          name: 'todo-list',
          component: TodoList
        },
        {
          path: 'categories',
          name: 'categories',
          component: CategoriesList
        },
        {
          path: 'chapters',
          name: 'chapters',
          component: ChaptersList
        },
        {
          path: 'dashboard-promotions',
          name: 'dashboard-promotions',
          component: DashboardPromotions
        },
        {
          path: 'tags',
          name: 'tags',
          component: TagsList
        },
        {
          path: 'users',
          name: 'users',
          component: UsersList
        },
        {
          path: 'user',
          name: 'user',
          component: User,
          children: [
            {
              path: 'invite',
              name: 'add-user',
              component: AddUser
            },
            {
              path: 'edit/:id',
              name: 'edit-user',
              component: EditUser
            }
          ]
        },
        {
          path: 'companies',
          name: 'companies',
          component: CompanyList
        },
        {
          path: 'company',
          name: 'company',
          component: Company,
          children: [
            {
              path: 'create',
              name: 'add-company',
              component: AddCompany
            },
            {
              path: 'edit/:id',
              name: 'edit-company',
              component: EditCompany
            }
          ]
        },
        {
          path: 'industries',
          name: 'industries',
          component: IndustryList
        },
        {
          path: 'industry',
          name: 'industry',
          component: Industry,
          children: [
            {
              path: 'create',
              name: 'add-industry',
              component: AddIndustry
            },
            {
              path: 'edit/:id',
              name: 'edit-industry',
              component: EditIndustry
            },
            {
              path: 'edit/:id/industry-emails',
              name: 'edit-industry-emails',
              component: EditIndustryEmails
            },
            {
              path: 'edit/:id/industry-styling',
              name: 'edit-industry-styling',
              component: EditIndustryStyling
            }
          ]
        },
        {
          path: 'new-articles-list',
          name: 'new-articles-list',
          component: NewArticlesList
        },
        {
          path: 'homepage',
          name: 'homepage',
          component: HomePage
        },
        {
          path: 'page/:id?',
          name: 'page',
          component: StaticPage
        },
        {
          path: 'default-email-templates',
          name: 'default-email-templates',
          component: EditDefaultEmails
        },
        {
          path: 'redirects',
          name: 'redirects',
          component: Redirects
        },
        {
          path: 'tasks/:companyId',
          name: 'company-tasks',
          component: Tasks
        },
        {
          path: 'tasks/:companyId/browse/:id',
          name: 'company-task',
          component: Task
        }
        // {
        //   path: 'ask/:id?',
        //   name: 'ask',
        //   component: AskPage
        // }
      ]
    },
    {
      path: '/dashboard',
      component: Admin,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '',
          name: 'user-app',
          component: NextGenDashboard,
          meta: {
            requiresAuthCARU: true
          }
        },
        {
          path: 'users',
          name: 'ca-users',
          component: UsersList,
          meta: {
            requiresAuthCATALA: true
          }
        },
        {
          path: 'user',
          name: 'ca-user',
          component: User,
          meta: {
            requiresAuthCATALA: true
          },
          children: [
            {
              path: 'invite',
              name: 'ca-add-user',
              component: AddUser
            },
            {
              path: 'edit/:id',
              name: 'ca-edit-user',
              component: EditUser
            }
          ]
        },
        {
          path: 'notifications',
          name: 'dashboard-notifications',
          component: Notifications
        },
        {
          path: 'tasks',
          name: 'tasks',
          component: Tasks,
          meta: {
            requiresAuth: true,
            requiresAuthCARU: true
          }
        },
        {
          path: 'tasks/browse/:id',
          name: 'task',
          component: Task,
          meta: {
            requiresAuth: true,
            requiresAuthCARU: true
          }
        },
        {
          path: 'knowledge-base',
          name: 'knowledge-base',
          component: KnowledgeBase
        }
      ]
    },
    {
      path: '/error',
      name: 'error',
      component: Error
    },
    {
      path: '/badge',
      name: 'badge',
      component: Badge
    },
    {path: '*', redirect: '/error'}
  ],
  scrollBehavior (to, from, savedPosition) {
    // savedPosition is only available for popstate navigations.
    if (savedPosition) return savedPosition

    // if the returned position is falsy or an empty object,
    // will retain current scroll position.
    if (to.params.savePosition) return {}

    // scroll to anchor by returning the selector
    if (to.hash) {
      let position = { selector: to.hash }

      // specify offset of the element
      // if (to.hash === '#anchor2') {
      //   position.offset = { y: 100 }
      // }
      return position
    }

    // scroll to top by default
    return { x: 0, y: 0 }
  }
})

export default router

router.beforeEach((to, from, next) => {
  setTimeout(function () {
    let element = document.getElementsByTagName('HEADER')
    if (element.length) {
      element[0].scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  }, 100)
  if (!localStorage.getItem('cookieFixed')) {
    localStorage.removeItem('token')
    localStorage.removeItem('userData')
    localStorage.removeItem('userIndustryName')
    localStorage.removeItem('userCompanyName')
  }
  if (to.name !== 'content' && window.ga) {
    window.ga('set', 'contentGroup2', null)
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('token')) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } if (to.matched.some(record => record.meta.isAuthorized)) {
    if (localStorage.getItem('token')) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } if (to.matched.some(record => record.meta.requiresAuthGM)) {
    let userData = JSON.parse(localStorage.getItem('userData'))
    if (userData && userData.userRole !== 'gm') {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  } if (to.matched.some(record => record.meta.requiresAuthCATALA)) {
    let userData = JSON.parse(localStorage.getItem('userData'))
    if (userData && (userData.userRole !== 'ca' && userData.userRole !== 'ta' && userData.userRole !== 'la')) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  } if (to.matched.some(record => record.meta.requiresAuthCARU)) {
    let userData = JSON.parse(localStorage.getItem('userData'))
    if (userData && (userData.userRole !== 'ca' && userData.userRole !== 'cu')) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  } if (to.matched.some(record => record.meta.dashboardRedirect)) {
    let userData = JSON.parse(localStorage.getItem('userData'))
    if (userData !== null) {
      if (userData.userRole === 'gm') {
        next({
          name: 'admin'
        })
      } else if (userData.userRole === 'ca' || userData.userRole === 'cu') {
        next({
          name: 'user-app'
        })
      } else {
        next({
          name: 'knowledge-base'
        })
      }
    }
  } else {
    next()
  }
  if (to.matched.some(record => record.meta.maybeLanding)) {
    let landing = localStorage.getItem('landing')
    if (landing !== null) {
      next({
        name: 'company-landing',
        params: {id: landing}
      })
    }
  } else {
    next()
  } if ((localStorage.getItem('consentSeen') &&
    localStorage.getItem('consentSeen') < 1) ||
    localStorage.getItem('userData') &&
    !localStorage.getItem('consentSeen')) {
    next({
      path: '/give-consent'
    })
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js